import { Package, PackageType } from '@frontend/package/types';
import { MobileWizardStateRecord } from '@frontend/wizard/mobile';

export interface PackageProofOfIdentityRequirement {
    packageType: PackageType;
}

interface PendingPackage {
    type: PackageType;
    require_proof_of_identity?: boolean;
}

export function isSenderCardProofRequirement(requirement: PackageProofOfIdentityRequirement): boolean {
    return requirement.packageType === PackageType.DROP_OFF;
}

export function isReceiverCardProofRequirement(requirement: PackageProofOfIdentityRequirement): boolean {
    return requirement.packageType === PackageType.PICK_UP;
}

export function resolvePackageProofOfIdentityRequirements(store: MobileWizardStateRecord | null): PackageProofOfIdentityRequirement[] {
    if (!store) return [];

    const requirements = new Map<PackageType, PackageProofOfIdentityRequirement>();

    const addRequirement = (packageType: PackageType, required: boolean | null | undefined) => {
        if (!required) return;
        requirements.set(packageType, { packageType });
    };

    for (const pkg of (store.data.packages as Package[] | undefined) ?? []) {
        addRequirement(pkg.type, pkg.require_proof_of_identity);
    }

    if (requirements.size === 0) {
        for (const pending of (store.data.pendingPackages as PendingPackage[] | undefined) ?? []) {
            addRequirement(pending.type, pending.require_proof_of_identity);
        }
    }

    if (requirements.size === 0) {
        addRequirement(PackageType.DROP_OFF, store.data.dropOffRequireProofOfIdentity as boolean | undefined);
        addRequirement(PackageType.PICK_UP, store.data.pickUpRequireProofOfIdentity as boolean | undefined);
    }

    return [...requirements.values()];
}
